// Types
import * as Types from '../types'
import { requestActionProps, requestGenerate, successGenerate } from "../../common";
import api from '../../../services/api'
import {callbackProps, ID, IClassroom, IClassroomCurriculum, IClassroomPost} from "../../../constants";
import {store} from "../../ROOT";
import {SET_STUDENT_LIST} from "../types";
import {SET_TASK_COMPLETED} from "../../onboarding/actions";

const actionGetClassrooms = (
  payload:any,
  callback?: (a: callbackProps) => void
): requestActionProps => ({
  type: requestGenerate(Types.SET_CLASSROOMS),
  api: api.getClassrooms,
  payload: { data: new URLSearchParams(payload) },
  callback,
});

const actionGetStaffClassrooms = (
  payload:any,
  callback?: (a: callbackProps) => void
): requestActionProps => ({
  type: requestGenerate(Types.SET_CLASSROOMS),
  api: api.getStaffClassrooms,
  payload: { data: new URLSearchParams(payload) },
  callback,
});


const actionGetClassroomById = (
  payload: ID,
  callback?: (a: callbackProps) => void
): requestActionProps => ({
  payload: { data: payload },
  type: requestGenerate(Types.REQUEST),
  api: api.getClassroomById,
  callback,
});

const actionCreateClassroom = (
  payload: IClassroomPost,
  callback?: (a: callbackProps) => void
): requestActionProps => ({
  payload: { data: payload },
  type: requestGenerate(Types.REQUEST),
  api: api.createClassroom,
  callback,
});

const actionUpdateClassroom = (
  payload: IClassroom,
  callback?: (a: callbackProps) => void
): requestActionProps => ({
  payload: { data: payload },
  type: requestGenerate(Types.REQUEST),
  api: api.updateClassroom,
  callback,
});



const actionPatchClassroomCurriculum = (
  payload: IClassroomCurriculum,
  callback?: (a: callbackProps) => void
): requestActionProps => ({
  payload: { data: payload },
  type: requestGenerate(Types.REQUEST),
  api: api.patchClassroomCurriculum,
  callback,
});

const actionDeleteClassroom = (
  payload: { id: ID },
  callback?: (a: callbackProps) => void
): requestActionProps => ({
  type: requestGenerate(Types.REQUEST),
  api: api.deleteClassroom,
  payload: { data: payload },
  callback,
});

const actionSaveSelectedClass = (
  payload: IClassroom,
) => ({
  type: successGenerate(Types.SET_CLASSROOM),
  payload: {data: payload},
  callback: (response: any) => {
    console.log('actionSaveSelectedClass', response)
  }
});


export {
  actionGetClassroomById,
    actionDeleteClassroom,
    actionUpdateClassroom,
    actionGetClassrooms,
    actionCreateClassroom,
  actionSaveSelectedClass,
  actionGetStaffClassrooms,
  actionPatchClassroomCurriculum
};
